import { BrandIdentityResponseDTO } from '../dtos/response/brandIdentity'
import { BrandIdentity } from '../entities/brandIdentity'

export class BrandIdentityMapper {
	static toEntity(data: BrandIdentityResponseDTO): BrandIdentity {
		return BrandIdentity.create({
			id: data.id,
			name: data.name,
			key: data.key,
			createdAt: data.created_at,
			updatedAt: data.updated_at,
		})
	}

	static toEntities(data: BrandIdentityResponseDTO[]): BrandIdentity[] {
		return data.map((item) => this.toEntity(item))
	}
}
